import { i18n } from "@/i18n";
import { SIDENAV_GROUP_BY } from "@/constants";
import { ARC_SERVICE } from "@/utils/services";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export const MSP_NAV_ITEMS = [
  {
    order: 3,
    label: i18n.global.t("sidebar-email-archiving"),
    groupBy: SIDENAV_GROUP_BY.BETA,
    icon: "cb-icon-email-archiving",
    id: buildOrgUrl("msp", null, "email_archiving"),
    dataTestId: "msp-arc-titan",
    solutionId: ARC_SERVICE,
    isExternal: false,
  },
];
export const CUSTOMER_NAV_ITEMS = [
  {
    order: 3,
    label: i18n.global.t("sidebar-email-archiving"),
    groupBy: SIDENAV_GROUP_BY.BETA,
    icon: "cb-icon-email-archiving",
    id: buildOrgUrl("customer", null, "email_archiving"),
    dataTestId: "customer-arc-titan",
    solutionId: ARC_SERVICE,
    isExternal: false,
  },
];

export default {};
